module.exports = __webpack_public_path__ + "static/uyguncozumler-92dd6eed84c08db2aef3ce1af5b65984.png";